import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UploadCompanionSessionAttachmentMutation,
  UploadCompanionSessionAttachmentMutationVariables,
} from "./UploadCompanionSessionAttachment.generated";

export const UPLOAD_COMPANION_SESSION_ATTACHMENT: TypedDocumentNode<
  UploadCompanionSessionAttachmentMutation,
  UploadCompanionSessionAttachmentMutationVariables
> = gql`
  mutation uploadCompanionSessionAttachment(
    $storageObjectName: String!
    $companionSessionUuid: String!
    $fileName: String!
    $contentType: String!
    $streamingTaskUuid: String
  ) {
    uploadCompanionSessionAttachment(
      storageObjectName: $storageObjectName
      companionSessionUuid: $companionSessionUuid
      fileName: $fileName
      contentType: $contentType
      streamingTaskUuid: $streamingTaskUuid
    ) {
      ok
    }
  }
`;
